import React, { useState } from 'react';
import { Card } from '../shadcn-ui/card';
import { ChevronDown, ChevronUp, Pencil } from 'lucide-react';
import MediaGrid from '../sharedComponents/MediaGrid';

export const formatDateTime = isoString => {
  const date = new Date(isoString);

  const datePart = date.toLocaleDateString('en-CA'); // YYYY-MM-DD
  const timePart = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${datePart} ${timePart}`;
};

const DryingBedCheckItem = ({ item, onEditClick }) => {
  const [open, setOpen] = useState(false);

  const handlePencilClick = () => {
    if (onEditClick) {
      onEditClick(item);
    }
  };

  return (
    <Card key={item?._id} className="flex justify-between p-3">
      <div className="flex flex-1 flex-col">
        <div className="font-medium">
          {item?.sequence_no}. {formatDateTime(item?.time_of_check)}
          {/* 2. 2025-12-01 8:30 PM */}
        </div>
        {!open ? (
          <div className="text-sm">
            Was coffee raked: {item?.was_coffee_raked ? 'Yes' : 'No'} •moisture: {item?.moisture}%{' '}
            {item?.temperature &&
              `• Temp:
            ${item?.temperature}°C`}
          </div>
        ) : (
          <div className="text-sm">
            <div className="flex items-center gap-1">
              <div className="font-medium">Was coffee raked: </div>
              {item?.was_coffee_raked ? 'Yes' : 'No'}
            </div>
            <div className="flex items-center gap-1">
              <div className="font-medium">Moisture: </div>
              {item?.moisture}%
            </div>
            <div className="flex items-center gap-1">
              <div className="font-medium">Temperature: </div>
              {item?.temperature ? `${item?.temperature}°C` : 'N/A'}
            </div>
            <div className="mb-1 flex items-center gap-1">
              <div className="font-medium">Notes: </div>
              {item?.notes}
            </div>
            {item?.media && <MediaGrid media={[...item?.media]} remove={false} />}
          </div>
        )}
      </div>
      <div className="mt-4 flex items-start justify-start gap-2">
        <button className="mr-1 flex-shrink-0" onClick={handlePencilClick}>
          <Pencil className="h-5 w-5" />
        </button>
        <button className="mr-1 flex-shrink-0" onClick={() => setOpen(!open)}>
          {open ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
        </button>
      </div>
    </Card>
  );
};

export default DryingBedCheckItem;
